// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADVANCED_ARTICLES_PREVIEW_GRID_HASHTAGS_TITLE = "S\u00favisiace #hashtagy";
export const ADVANCED_ARTICLES_PREVIEW_GRID_SUBTITLE_count_HOWTOS = "Vyberajte z %(count)s n\u00e1vodov";
export const ADVANCED_ARTICLES_PREVIEW_GRID_SUBTITLE_count_RECIPES = "Vyberajte z %(count)s receptov";
export const BOOKMARKED_HOWTOS = "Ob\u013e\u00faben\u00e9 n\u00e1vody";
export const BOOKMARKED_RECIPES = "Ob\u013e\u00faben\u00e9 recepty";
export const count_HOWTOS = ["%(count)s n\u00e1vod", "%(count)s n\u00e1vody", "%(count)s n\u00e1vodov"];
export const count_RECIPES = ["%(count)s recept", "%(count)s recepty", "%(count)s receptov"];
export const DRAFT_HOWTOS = "Rozp\u00edsan\u00e9 n\u00e1vody";
export const DRAFT_RECIPES = "Rozp\u00edsan\u00e9 recepty";
export const MY_HOWTOS = "Moje n\u00e1vody";
export const MY_RECIPES = "Moje recepty";
export const NO_RESULTS = "\u017diadne v\u00fdsledky";
export const number_MINUTES = ["%(number)s min\u00fata", "%(number)s min\u00faty", "%(number)s min\u00fat"];
export const PB_MENU_HOWTOS = "N\u00e1vody";
export const PB_MENU_RECIPES = "Recepty";
export const SHOW_MORE = "Zobraz viac";
